module.exports = __webpack_public_path__ + "img/盖章@3x.00261d95.png";